import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";


const OpenAPIClientAxios = require("openapi-client-axios").default;
const api = new OpenAPIClientAxios({
  definition: "http://93.170.73.27/api/openapi.json",
  axiosConfigDefaults: {
    // baseURL: "http://" + window.location.host.replace(":8001", ""),
    baseURL: "http://" + '93.170.73.27',
    timeout: 10000,
    params: {
      filter_date: new Date().toJSON().slice(0, 10),
    },
  },
});
Vue.prototype.$client = null;

api.init().then((client) => {
  Vue.prototype.$client = client
})



Vue.config.productionTip = false;


Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

new Vue({
  mode: "history",
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
